import React, { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { useToggle } from '../../../../hooks/toggle';
import { useCurrency } from '../../../../hooks/currency';
import { useApiQuery } from '@orderx/lab/xr/http';
import { apiOrderOrderIdReceiptGet } from '../../../../api/order.{orderId}.receipt.[get]';
import { XLoader } from '../../../x/loader/XLoader';
import { XTable } from '@orderx/lab/ui';

interface ApiResponse {
    detailed: {
        id: number;
        name: string;
        price: number;
        rows: {
            id: number;
            name: string;
            groupName: string;
            price: number;
        }[];
    }[];
    grouped: {
        id: number;
        name: string;
        count: number;
        price: number;
    }[];
}

const Wrapper = styled.div``;

interface Props {
    orderId: number;
}

export function OrderReceiptOrderProducts({ orderId }: Props) {
    const [isDetailed, toggleIsDetailed] = useToggle();
    const { format } = useCurrency();

    const apiQuery = useApiQuery<ApiResponse>(() => apiOrderOrderIdReceiptGet({ params: { orderId } }));

    useEffect(() => {
        apiQuery.run();
    }, []);

    if (!apiQuery.response) {
        return <XLoader />;
    }

    const { detailed, grouped } = apiQuery.response;

    return (
        <Wrapper onClick={toggleIsDetailed}>
            {isDetailed ? (
                <XTable>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td align="right">Price</td>
                        </tr>
                    </thead>

                    <tbody>
                        {detailed.map((item) => (
                            <Fragment key={item.id}>
                                <tr>
                                    <td>{item.name}</td>
                                    <td align="right">{format(item.price)}</td>
                                </tr>

                                {item.rows.map((row) => (
                                    <tr key={row.id}>
                                        <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;{row.groupName} - {row.name}
                                        </td>
                                        <td align="right">{format(row.price)}</td>
                                    </tr>
                                ))}
                            </Fragment>
                        ))}
                    </tbody>
                </XTable>
            ) : (
                <XTable>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td align="right">Count</td>
                            <td align="right">Price</td>
                        </tr>
                    </thead>

                    <tbody>
                        {grouped.map((item) => (
                            <tr key={item.id}>
                                <td>{item.name}</td>
                                <td align="right">{item.count}</td>
                                <td align="right">{format(item.price)}</td>
                            </tr>
                        ))}
                    </tbody>
                </XTable>
            )}
        </Wrapper>
    );
}
